/// <amd-module name="Repos/Tfvc/Views/ChangeDetails/ChangeDetailsContext" />
import * as React from "react";
import { IChangesFilesService, IChangesNavigationService } from "Repos/ChangesCommon/Contracts";
import { TfvcVersionDescriptor } from "Repos/Common/Contracts/Git";
import { IDiscussionIntegrationService } from "Repos/Discussion/Common/DiscussionContracts";
import { IChangeDetailsViewService } from "./ChangeDetailsViewService";

export interface IChangeDetailsContext {
    discussionService?: IDiscussionIntegrationService;
    extensionContext: {
        dependencies: string[];
        childComponentProperties: any;
        componentRegion: string;
    };
    filesService: IChangesFilesService<TfvcVersionDescriptor>;
    getFileUrl?: (filePath: string) => string;
    navigationService: IChangesNavigationService<TfvcVersionDescriptor>;
    perfContext: {
        scenarioName: string;
        pendingWorkName: string;
    };
    viewService: IChangeDetailsViewService;
}

export const ChangeDetailsContext = React.createContext<IChangeDetailsContext>({} as IChangeDetailsContext);

/**
 * Custom hook to use the tfvc change details context in functional components
 */
export function useChangeDetailsContext<TChange>(): IChangeDetailsContext {
    return React.useContext(ChangeDetailsContext);
}
